import { startCase } from 'lodash';
import { omit } from 'lodash/fp';

import {
  CheckMetadata,
  CheckMetadataItemType,
  TableCheckMetadataItem,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import {
  DatabaseTwoPlusTwoDetection,
  DatabaseTwoPlusTwoDetectionMatchResult,
} from 'dashboard/models/check';

const matchAttributeDisplayText: Partial<
  Record<keyof DatabaseTwoPlusTwoDetectionMatchResult, string>
> = {
  name: 'Name',
  birthdate: 'Birthdate',
  address: 'Address',
  'email-address': 'Email Address',
  'phone-number': 'Phone Number',
  'social-security-number': 'Identification Number',
};

export const computeDatabaseTwoPlusTwoComparisonDetectionMetadata = (
  check: DatabaseTwoPlusTwoDetection,
): CheckMetadata => {
  if (check.metadata && check.metadata['data-sources-match-results']) {
    const matchResults = check.metadata['data-sources-match-results'];
    const metadata = [] as TableCheckMetadataItem[];

    {
      matchResults.map((matchResult, index) => {
        const matchSource = ['none', undefined].includes(matchResult.category)
          ? `Source ${index + 1}`
          : matchResult.category;

        const rows = Object.entries(
          omit(['category'], matchResult as DatabaseTwoPlusTwoDetectionMatchResult),
        ).map((attributeResult) => {
          const [attributeName, matchValue] = attributeResult;
          return [
            matchAttributeDisplayText[
              attributeName as keyof DatabaseTwoPlusTwoDetectionMatchResult
            ] || attributeName,
            startCase(matchValue),
          ];
        });

        metadata.push({
          type: CheckMetadataItemType.Table,
          heading: {
            title: startCase(matchSource),
          },
          rowHeaders: ['Attribute', 'Match Result'],
          rows,
        });
      });
    }

    return {
      metadata,
      hideIfVerificationPassed: false,
    };
  }

  return {
    metadata: [],
    hideIfVerificationPassed: false,
  };
};
